
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground, PropsTable } from 'docz';
import { useState } from 'react';
import Text from "../shared/components/Text.js"
import "../shared/css/index.css"

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"text"}}>{`Text`}</MDXTag>
<MDXTag name="p" components={components}>{`Todo, o la mayoría, del texto de Oráculo debe ser agrupado dentro de un `}<MDXTag name="inlineCode" components={components} parentName="p">{`<Text />`}</MDXTag></MDXTag>
<Playground __position={0} __code={'() => {\n  const sizes = [14, 16, 18, 20, 24, 32, 48]\n  const weights = [100, 200, 300, 400, 500, 600, 700, 800, 900]\n  const aligns = [\'left\', \'center\', \'right\']\n  const types = [\'inline\', \'paragraph\']\n  const [size, setSize] = useState(24)\n  const [weight, setWeight] = useState(600)\n  const [uppercase, setUppercase] = useState(false)\n  const [align, setAlign] = useState(\'left\')\n  const [type, setType] = useState(\'inline\')\n  const [strong, setStrong] = useState(false)\n  const [italic, setItalic] = useState(false)\n\n  return (\n    <div>\n      <div>\n        <label>Size</label>\n        <select value={size} onChange={e => setSize(Number(e.target.value))}>\n          {sizes.map(sizeVal => (\n            <option value={sizeVal}>{sizeVal}</option>\n          ))}\n        </select>\n      </div>\n      <div>\n        <label>Weight</label>\n        <select\n          value={weight}\n          onChange={e => setWeight(Number(e.target.value))}\n        >\n          {weights.map(weightVal => (\n            <option value={weightVal}>{weightVal}</option>\n          ))}\n        </select>\n      </div>\n      <div>\n        <label>Align</label>\n        <select value={align} onChange={e => setAlign(e.target.value)}>\n          {aligns.map(alignVal => (\n            <option value={alignVal}>{alignVal}</option>\n          ))}\n        </select>\n      </div>\n      <div>\n        <label>Type</label>\n        <select value={type} onChange={e => setType(e.target.value)}>\n          {types.map(typeVal => (\n            <option value={typeVal}>{typeVal}</option>\n          ))}\n        </select>\n      </div>\n      <div>\n        <label>Uppercase</label>\n        <input type=\"checkbox\" onChange={() => setUppercase(v => !v)} />\n      </div>\n      <div>\n        <label>Italic</label>\n        <input type=\"checkbox\" onChange={() => setItalic(v => !v)} />\n      </div>\n      <div>\n        <label>Strong</label>\n        <input type=\"checkbox\" onChange={() => setStrong(v => !v)} />\n      </div>\n      <Text weight={weight}>\n        Puedes tener un componente Text,{\' \'}\n        <Text\n          align={align}\n          size={size}\n          type={type}\n          uppercase={uppercase}\n          italic={italic}\n          strong={strong}\n        >\n          dentro de otro, como este\n        </Text>\n        !\n      </Text>\n    </div>\n  )\n}'} __scope={{props: this ? this.props : props,useState,Text}}>
  {() => {
    const sizes = [14,16,18,20,24,32,48];
    const weights = [100,200,300,400,500,600,700,800,900];
    const aligns = ['left', 'center', 'right'];
    const types = ['inline', 'paragraph'];
const [size, setSize] = useState(24);
const [weight, setWeight] = useState(600);
const [uppercase, setUppercase] = useState(false);
const [align, setAlign] = useState('left');
const [type, setType] = useState('inline');
const [strong, setStrong] = useState(false);
const [italic, setItalic] = useState(false);

return (
  <div>
    <div>
      <label>Size</label>
      <select value={size} onChange={
        (e) => setSize(Number(e.target.value))
      }>
        {sizes.map(sizeVal => <option value={sizeVal}>{sizeVal}</option>)}
      </select>
    </div>
    <div>
      <label>Weight</label>
      <select value={weight} onChange={
        (e) => setWeight(Number(e.target.value))
      }>
        {weights.map(weightVal => <option value={weightVal}>{weightVal}</option>)}
      </select>
    </div>
    <div>
      <label>Align</label>
      <select value={align} onChange={
        (e) => setAlign(e.target.value)
      }>
        {aligns.map(alignVal => <option value={alignVal}>{alignVal}</option>)}
      </select>
    </div>
    <div>
      <label>Type</label>
      <select value={type} onChange={
        (e) => setType(e.target.value)
      }>
        {types.map(typeVal => <option value={typeVal}>{typeVal}</option>)}
      </select>
    </div>
    <div>
      <label>Uppercase</label>
      <input type="checkbox" onChange={() => setUppercase(v => !v)} />
    </div>
    <div>
      <label>Italic</label>
      <input type="checkbox" onChange={() => setItalic(v => !v)} />
    </div>
    <div>
      <label>Strong</label>
      <input type="checkbox" onChange={() => setStrong(v => !v)} />
    </div>
    <Text weight={weight}>Puedes tener un componente Text, <Text align={align} size={size} type={type} uppercase={uppercase} italic={italic} strong={strong}>dentro de otro, como este</Text>!</Text>
  </div>
)
  }}
</Playground>
<PropsTable of={Text} />
           </MDXTag>
  }
}
  